import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Countdown } from './Countdown';
import { Kicker } from './Section';
import { LAUNCH_DEADLINE_LABEL } from '../config/launch';
export function Urgency() {
  const {
    expired
  } = useCountdown();
  if (expired) return null;
  return <section aria-label="Launch price countdown" className="w-full bg-forest text-white" data-id="element-302" data-mp="21xynl6mgba51">
      <div className="mx-auto max-w-content px-5 py-16 text-center sm:px-8 sm:py-20" data-id="element-303" data-mp="1o6juu82qruks">
        <Kicker data-id="element-304" data-mp="1sxtlnc0113y9">Launch price — 24 hours</Kicker>
        <div className="mt-7" data-id="element-305" data-mp="1sylewg65ipld">
          <Countdown data-id="element-306" data-mp="1szmr4nywli4o" />
        </div>
        <p className="mt-7 font-sans text-[15px] text-white/75" data-id="element-307" data-mp="1e9fgguf513ej">
          Then it returns to the regular price of $97.
        </p>
        <p className="mx-auto mt-3 max-w-xl font-sans text-[13px] text-white/70" data-id="element-308" data-mp="1j8icjpd53zad">
          Your 24 hours at the launch price start on your first visit, and the offer closes for
          everyone on {LAUNCH_DEADLINE_LABEL}.
        </p>
      </div>
    </section>;
}